export const DEFAULT_PARTNER = {
  firstName: 'Someone',
  lastName: 'Special',
};

export const ACCOUNT_ERROR_MESSAGES = {
  invalidEmail: 'Please make sure to enter a valid email address.',
  invalidPassword: 'Please make sure your password is at least 8 characters.',
  emptyWeddingDetails: 'Please make sure you enter both first and last names.',
  invalidWeddingDate: 'Please make sure your wedding date is valid',
  invalidWeddingDetails: 'Please make sure your wedding details are valid.',
};



// WEBPACK FOOTER //
// ./src/paper/utils/constants.js